import React, { Fragment, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { SimTable, GlgTableCol } from 'SharedComponents'
import LeagueRowComponentSimGolf from './league_row_component_sim_golf'

const LeaguesTableComponentSimGolf = ({ leagues, leagueActions, categories, seasonsEnabled }) => {
  const [dimension, setDimension] = useState(window.innerWidth)

  useEffect(() => {
    window.addEventListener('resize', handleResize, false)
  }, [])

  const handleResize = () => {
    setDimension(window.innerWidth)
  }

  const rowExtraProps = {
    ...leagueActions,
    seasonsEnabled: seasonsEnabled,
  }

  return (
    <SimTable items={ leagues }
      rowComponent={ LeagueRowComponentSimGolf }
      rowExtraProps={ rowExtraProps }
      categoryColor={ categories }
      key={ Math.random() }
      className={ dimension <= 992 && 'responsive_table_sim_golf' }
    >
      <GlgTableCol width='50%' dataKey='name'>{ window.I18n.t('customer_center_comp.components.table_headers.name') }</GlgTableCol>
      <GlgTableCol width='10%' dataKey='startDate'>{ window.I18n.t('customer_center_comp.components.table_headers.start_date') }</GlgTableCol>
      <GlgTableCol width='10%' dataKey='seasonName'>{ window.I18n.t('customer_center_comp.components.table_headers.season') }</GlgTableCol>
      <GlgTableCol width='10%' dataKey='golfHub'>{ window.I18n.t('customer_center_comp.components.table_headers.golf_hub_page') }</GlgTableCol>
      <GlgTableCol width='10%' dataKey='registrationMessage'>{ window.I18n.t('customer_center_comp.components.table_headers.registration') }</GlgTableCol>
      <GlgTableCol width='5%' dataKey='golfers'>{ window.I18n.t('customer_center_comp.components.table_headers.golfers') }</GlgTableCol>
      <GlgTableCol width='5%'>{ window.I18n.t('customer_center_comp.components.table_headers.actions') }</GlgTableCol>
    </SimTable>
  )
}

LeaguesTableComponentSimGolf.propTypes = {
  leagues: PropTypes.array.isRequired,
  leagueActions: PropTypes.object.isRequired,
  categories: PropTypes.array.isRequired,
  seasonsEnabled: PropTypes.bool,
}

export default LeaguesTableComponentSimGolf